import { AxiosError } from 'axios';

import is404Response from '@utils/is404Response';

const dontRetry404 = (failureCount: number, error: unknown) => {
    // 404 is an expected error for no data, so we don't want to retry it
    if (is404Response((error as AxiosError).response)) {
        return false;
    }
    return failureCount < 3;
};

export default dontRetry404;
